export default __webpack_public_path__ + "images/5cdaeb144951a21f4ad8d0925b206452.svg";